/**
 * Created by jonas on 2021-02-09.
 */
import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {ISimpleReelModelDelegate, SimpleReelModel} from "../../core/reel/simplereel/SimpleReelModel";
import {DjPsycho} from "../DjPsycho";
import {DjPsychoSymbol, DjPsychoSymbolStates} from "./DjPsychoSymbol";

export class DjPsychoReelsView extends PIXI.Container implements StageLayer, ISimpleReelModelDelegate {

    public static stepDuration: number = 0.06;
    private _symbolContainer: PIXI.Container;

    constructor() {
        super();
        this.init();
    }

    private _reelModels: SimpleReelModel[];

    get reelModels(): SimpleReelModel[] {
        return this._reelModels;
    }

    public createSymbol(symbolName: string, reelID: number, soundId: number): DjPsychoSymbol {
        let originalName: string = symbolName;

        if (symbolName === "X") {
            symbolName = "L1";
        }

        const symbolState: DjPsychoSymbolStates = DjPsychoSymbolStates.NORMAL;
        const symbol: DjPsychoSymbol = new DjPsychoSymbol(symbolName, symbolState, soundId);
        symbol.x = (reelID * DjPsycho.symbolWidth) + (DjPsycho.symbolWidth * 0.5) + (reelID * DjPsycho.padding);
        symbol.anchor.set(0.5, 0.5);
        this._symbolContainer.addChild(symbol);

        if (originalName === "X") {
            symbol.alpha = 0;
        }

        return symbol;
    }

    public removeSymbol(symbol: DjPsychoSymbol): void {
        symbol.destroy();
    }

    public getVisibleSymbolAt(column: number, row: number): DjPsychoSymbol {
        const visibleSymbols: DjPsychoSymbol[] = this._reelModels[column].symbols;
        return visibleSymbols[row];
    }

    private init(): void {
        this._symbolContainer = new PIXI.Container();
        this._symbolContainer.position.set(DjPsycho.reelViewX, DjPsycho.reelViewY);
        this.addChild(this._symbolContainer);

        this._reelModels = [];
        for (let i: number = 0; i < DjPsycho.reelsNum; i++) {
            const reel: SimpleReelModel = new SimpleReelModel(i, this, true);
            reel.stepDuration = DjPsychoReelsView.stepDuration;
            reel.stepSize = DjPsycho.symbolHeight;
            reel.init(DjPsycho.model.data.reels[i].concat());

            this._reelModels.push(reel);
        }

        const allSize: number[][] = DjPsycho.model.initData.allSize;
        if (DjPsycho.model.isRestore && allSize) {
            allSize.forEach((size: number[], reel: number) => {
                size.forEach((val: number, symId: number) => {
                    if (val === 2) {
                        this.getVisibleSymbolAt(reel, symId).setSymbolCount();
                    }
                });
            });
        }
    }
}